import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators as bind } from 'redux';
import Result from '../components/DebtConsolidationFlow/Result';
import { mp } from '../constants/utils';

import Flow from '../components/DebtConsolidationFlow/Flow';

import { Debt } from '../data/ducks';
import { consolidacionCredito } from '../constants/questionnaires';

const DebtConsolidationSteps = [
  Flow,
  Result,
];

const originalQuestionnaire = [
  {
    label: '',
    value: '',
    totalQuestions: 7,
    questions: consolidacionCredito,
  },
];

class DebtConsolidationContainer extends Component {
  state = {
    currentStep: 0,
    totalSteps: DebtConsolidationSteps.length,
  };

  componentWillMount = () => {
    this.setState({
      questionnaire: originalQuestionnaire,
    });
  }

  nextStep = () => {
    const { currentStep, totalSteps } = this.state;
    if (currentStep < (totalSteps - 1)) {
      this.setState(state => ({ currentStep: state.currentStep + 1 }));
    }
  };

  handleStepSubmit = (data) => {
    switch (this.state.currentStep) {
      case 0:
        mp('Deuda | Obtener Resultados');
        this.props.calculateDebtConsolidation(data[0]);
        break;
      default: break;
    }
    this.nextStep();
  }

  render() {
    const CurrentStep = DebtConsolidationSteps[this.state.currentStep];
    return (
      <Fragment>
        <CurrentStep
          nextStep={this.nextStep}
          onStepSubmit={this.handleStepSubmit}
          questionnaire={this.state.questionnaire}
          result={this.props.result}
        />
      </Fragment>
    );
  }
}

DebtConsolidationContainer.propTypes = {
  result: PropTypes.object,
  calculateDebtConsolidation: PropTypes.func,
  // sendEmail: PropTypes.func,
};

DebtConsolidationContainer.defaultProps = {
  result: {},
  calculateDebtConsolidation: () => {},
  // sendEmail: () => {},
};

const mapStateToProps = state => ({
  result: state.debt.result,
});

const mapDispatchToProps = dispatch => bind({
  calculateDebtConsolidation: Debt.Creators.calculateDebtConsolidationRequested,
  // sendEmail: Emails.Creators.sendEmailRetirementRequested,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DebtConsolidationContainer);
